import {
  StackLayout,
  TextInput,
  StackItem,
  Button,
} from '@leagueplatform/genesis-core';
import { FilterSelect } from './FilterSelect';
import { useFiltering } from '../../utils/useFiltering';
import { domains, product_areas, event_names } from '../../utils/constants';

export function FilterToolbar() {
  const { setSearchValue, searchValue, clearFilters } = useFiltering();


  const filters = [
    {
      key: 'domain',
      label: 'Domain',
      data: domains,
    },
    {
      key: 'event_name',
      label: 'Event Name',
      data: event_names,
    },
    {
      key: 'product_area',
      label: 'Product Area',
      data: product_areas,
    },
  ];

  return (
    <StackLayout
      css={{
        gap: '$oneAndHalf',
        marginY: '$oneAndHalf',
      }}
      orientation="horizontal"
    >
      <StackItem
        css={{
          width: '50%',
          gap: '$oneAndHalf',
          flexDirection: 'row',
        }}
      >
        {filters.map((filter) => (
          <FilterSelect
            key={filter.key}
            id={filter.key}
            label={filter.label}
            data={filter.data}
          />
        ))}
      </StackItem>
      <TextInput
        value={searchValue}
        onChange={(e) => setSearchValue(e.currentTarget.value)}
        id="placeholder"
        placeholder="Search by Domain, Event Name, or Product Area"
        css={{ maxWidth: '400px', width: '100%' }}
      />
      <Button
        onClick={() => {
          clearFilters();
        }}
      >
        Clear
      </Button>
    </StackLayout>
  );
}
